import { xdmContextDelimiter } from '../components/POSGroupFilter/POSGroupFilterConstants';

export const adjustGroupId = (groupId: string) => {
  // Adjust groupId for XdmContext
  return groupId.split(xdmContextDelimiter)[0];
};
